let key = 0;

export const createTheColumnsOfSameTitle = (title, links, type, maxNumberOfRows) => {
  const numberOfColumns = Math.ceil(links.length / maxNumberOfRows);
  const columns = [];
  for (let i = 0; i < numberOfColumns; ++i) {
    const column = { key: ++key, type: type, title: (i === 0 ? title : '\u00A0'), links: [] };
    while (column.links.length < maxNumberOfRows && links.length > 0) {
      column.links.push(links.shift());
    }
    columns.push(column);
  }
  return columns;
};

export const createColumnsOfDropdown = (titleAndLinksList, maxNumberOfRows, columnType) => {
  const columnsOfAllTitles = [];
  for (let i = 0; i < titleAndLinksList.length; ++i) {
    const columns = createTheColumnsOfSameTitle(titleAndLinksList[i].title, titleAndLinksList[i].links,
      columnType, maxNumberOfRows);
    columnsOfAllTitles.push(...columns);
  }
  return columnsOfAllTitles;
};
